var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-play-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M175 100C175 141.422 141.422 175 100 175C58.5787 175 25 141.422 25 100C25 58.5787 58.5787 25 100 25C141.422 25 175 58.5787 175 100Z",
    stroke: "#F7F7F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M125.023 94.4538C127.805 96.308 129.196 97.2355 129.681 98.4046C130.105 99.4263 130.105 100.575 129.681 101.596C129.196 102.765 127.805 103.693 125.023 105.547L93.7088 126.424C90.3413 128.669 88.6579 129.791 87.2621 129.708C86.0462 129.635 84.9221 129.034 84.1871 128.062C83.3438 126.947 83.3438 124.924 83.3438 120.877V79.1239C83.3438 75.0774 83.3438 73.0541 84.1871 71.9389C84.9221 70.9672 86.0462 70.366 87.2621 70.2934C88.6579 70.2101 90.3413 71.3323 93.7088 73.5769L125.023 94.4538Z",
    stroke: "#F7F7F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8503ebbe00f753aee60ec693dac15fbe.svg";
export { ForwardRef as ReactComponent };